export default __webpack_public_path__ + "static/media/ios_dev.aa59d227.svg";